import { useState, type FormEvent } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '@/store/auth'
import { toastError } from '@/store/toast'
import { ApiClientError } from '@/lib/api'

export default function LoginPage() {
  const navigate = useNavigate()
  const login = useAuth((s) => s.login)
  const user = useAuth((s) => s.user)
  const loading = useAuth((s) => s.loading)
  const [username, setUsername] = useState('admin')
  const [password, setPassword] = useState('')

  if (user) return <Navigate to="/" replace />

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    try {
      await login(username, password)
      navigate('/', { replace: true })
    } catch (err) {
      const msg =
        err instanceof ApiClientError
          ? err.message
          : 'เข้าสู่ระบบไม่สำเร็จ — ลองใหม่อีกครั้ง'
      toastError(msg)
    }
  }

  return (
    <div className="min-h-full flex items-center justify-center bg-gradient-to-br from-brand-700 to-brand-900 p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-6 text-white">
          <h1 className="text-3xl font-bold">Work Evolution</h1>
          <p className="opacity-80 mt-1">ระบบออกใบเสร็จ — คลินิกกายภาพบำบัด</p>
        </div>
        <form onSubmit={handleSubmit} className="card space-y-4">
          <h2 className="text-lg font-semibold text-center">เข้าสู่ระบบ</h2>
          <div>
            <label className="label">ชื่อผู้ใช้</label>
            <input
              className="input"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div>
            <label className="label">รหัสผ่าน</label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={loading}>
            {loading ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบ'}
          </button>
          <p className="text-center text-sm text-slate-500">
            ทดสอบ: admin / admin123
          </p>
        </form>
      </div>
    </div>
  )
}
